import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem('token'); // Or get it from a service

  if (token) {
    return true; // ✅ Allow access if token exists
  } else {
    router.navigate(['/login']); // 🔒 Redirect to login page if not authenticated
    return false;
  }
};
